export const flattenEditableProps = (obj, prefix = '') => {
    let result = {};
    Object.keys(obj || {}).forEach((key) => {
        const value = obj[key];
        const newKey = prefix ? `${prefix}.${key}` : key;

        if (value && typeof value === 'object' && !('value' in value) && !('type' in value)) {
            result = {
                ...result,
                ...flattenEditableProps(value, newKey)
            };
        } else {
            result[newKey] = value;
        }
    });

    return result;
};
